import { gql } from "@apollo/client";

export const TRAVEL_RESERVATION_SUMMARY_FRAGMENT = gql`
  fragment TravelReservationSummaryFields on TravelReservationSummaryDefinition {
    id
    saleOrderCode
    bookingStatus
    paymentStatus
    total
    currency
    createdAt
    updatedAt
    reservationType
    customerName
    customerEmail
    customerPhone
    travelSummary
    confirmationCode
  }
`;

export const TRAVEL_RESERVATION_FULL_FRAGMENT = gql`
  fragment TravelReservationFullFields on TravelReservationDefinition {
    id
    saleOrderCode
    bookingStatus
    paymentStatus
    total
    subtotal
    fees
    taxes
    currency
    protectionId
    userId
    createdAt
    updatedAt
    confirmationEmailSentAt
    reservationType
    customer {
      id
      firstName
      lastName
      email
      phone
    }
    payer {
      id
      firstName
      lastName
      email
      phone
    }
    payment {
      id
      paymentMethod
      status
      total
      currency
      providerTransactionId
      failureReason
      createdAt
    }
    flight {
      id
      reservationId
      supplierLocator
      originAirportCode
      destinationAirportCode
      originCityName
      destinationCityName
      mainAirlineCode
      mainAirlineName
      firstDepartureDate
      tripType
      status
      passengersMetadata
      departSegmentsMetadata
      returnSegmentsMetadata
      unitPrice
      taxes
    }
    hotel {
      id
      bookingId
      hotelName
      cityName
      countryName
      checkInDate
      checkOutDate
      checkInHour
      checkOutHour
      roomsCount
      adults
      children
      numberOfNights
      status
      cancellationPolicy
      passengersMetadata
      roomsMetadata
      unitPrice
      taxes
    }
    rentACar {
      id
      bookingId
      providerCode
      vendorName
      carModel
      transmissionType
      pickupCity
      dropoffCity
      pickupDate
      dropoffDate
      status
      passengersMetadata
      driverMetadata
      unitPrice
      taxes
    }
    tour {
      id
      bookingId
      supplierReservationCode
      name
      activityCategory
      activityType
      cityName
      address
      startDate
      checkInDate
      checkOutDate
      numberOfAdults
      status
      passengersMetadata
      unitPrice
      taxes
    }
  }
`;

export const GET_TRAVEL_RESERVATIONS = gql`
  ${TRAVEL_RESERVATION_SUMMARY_FRAGMENT}
  query GetTravelReservations(
    $filter: TravelReservationSearchInput!
    $pageNumber: Int
    $pageSize: Int
    $sort: TravelReservationSortInput
  ) {
    travelReservations(
      filter: $filter
      pageNumber: $pageNumber
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        ...TravelReservationSummaryFields
      }
      count
      pageNumber
      pageSize
    }
  }
`;

export const GET_TRAVEL_RESERVATION_BY_ID = gql`
  ${TRAVEL_RESERVATION_FULL_FRAGMENT}
  query GetTravelReservationById($id: String!) {
    travelReservationById(id: $id) {
      ...TravelReservationFullFields
    }
  }
`;

export const GET_TRAVEL_RESERVATION_BY_ORDER_CODE = gql`
  ${TRAVEL_RESERVATION_FULL_FRAGMENT}
  query GetTravelReservationByOrderCode($orderCode: String!) {
    travelReservationByOrderCode(orderCode: $orderCode) {
      ...TravelReservationFullFields
    }
  }
`;

export const GET_TRAVEL_RESERVATION_COUNT = gql`
  query GetTravelReservationCount($bookingStatus: String, $paymentStatus: String) {
    travelReservationCount(bookingStatus: $bookingStatus, paymentStatus: $paymentStatus)
  }
`;

export const TRAVEL_RESERVATION_NOTE_FRAGMENT = gql`
  fragment TravelReservationNoteFields on TravelReservationNoteDefinition {
    id
    content
    createdByName
    createdAt
  }
`;

export const GET_TRAVEL_RESERVATION_NOTES = gql`
  ${TRAVEL_RESERVATION_NOTE_FRAGMENT}
  query GetTravelReservationNotes($id: String!) {
    travelReservationNotes(id: $id) {
      ...TravelReservationNoteFields
    }
  }
`;
